//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EditDialog from '@/components/admin/EditDialog'
import ConfirmDialog from '@/components/ConfirmDialog'
import apiService from "@/services/APIService";
import ManufacturerPostDialog from "@/views/admin/ManufacturerPostDialog";
import {mapActions, mapState} from "vuex";
export default {
  name: "PostList",
  components: {
    ManufacturerPostDialog,
    ConfirmDialog,
    EditDialog
  },
  data () {
    return {
      selectedPostId: undefined,
      showNavigation: false,
      showSidepanel: false,
      loading: false,
    }
  },
  methods: {
    ...mapActions(['deleteManufacturerInfo', 'fetchOwnManufacturerPosts']),
    addInfo() {
      this.$refs.editDialog.show()
    },
    editInfo(info) {
      this.loading = true
      apiService.getManufacturerInfo(info.id).then((info) => {
        this.info = info
        this.ticked = [...this.info.processes]
        this.loading = false
        this.$refs.editDialog.show(info)
      })
    },
    deleteInfo(info) {
      this.$refs.confirmDialog.show(`Möchten sie "${ info.title }" löschen?`, 'Löschen')
          .then(this.deleteManufacturerInfo(info))
    },
    preview(info){
      this.$refs.manufacturerPostDialog.show(info);
    }
  },
  computed: {
    ...mapState(['ownManufacturerInfos']),
  },
  mounted() {
    this.fetchOwnManufacturerPosts()
  }
}
